import { FC, ReactNode, SyntheticEvent, useMemo } from 'react';
import { Order, useOrderState } from 'entities/orders';
import { BasicCircleButton } from 'shared/ui/buttons/iconButtons/circleButtons';

interface RecourceButtonProps {
	children: ReactNode;
	order?: Order;
	onClick?: (event: SyntheticEvent) => void;
	withBorder?: boolean;
}

export const RecourceButton: FC<RecourceButtonProps> = ({
	children,
	order,
	onClick,
	withBorder,
}) => {
	const { isVisitEnd, isVisitProgress, isVisitDelay, isVisitWaiting } =
		useOrderState(order);

	const variant = useMemo(() => {
		if (isVisitEnd) {
			return;
		}

		if (isVisitProgress) {
			return 'warning';
		}

		if (isVisitDelay) {
			return 'danger';
		}

		if (isVisitWaiting) {
			return 'info';
		}
	}, [isVisitEnd, isVisitProgress, isVisitDelay, isVisitWaiting]);

	return (
		<BasicCircleButton variant={variant} onClick={onClick} withBorder={withBorder}>
			{children}
		</BasicCircleButton>
	);
};
